export default __webpack_public_path__ + "static/media/setting.8e865822.svg";